import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main__section signup" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("회원 관리를 위하여 아래와 같이 개인정보를 수집·이용 및 제공하고자 합니다.")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 가입에 필요한 필수 정보를 입력해 주세요. ")
const _hoisted_7 = {
  key: 0,
  class: "privacy-policy"
}
const _hoisted_8 = { class: "agree-all" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "agreeAll",
  class: "-medium"
}, " 모든 약관을 동의합니다. ", -1)
const _hoisted_10 = { class: "request-form__footer--actions" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("다음")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("가입하기")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _directive_simpleHeader = _resolveDirective("simpleHeader")

  return _withDirectives((_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      _createVNode(_component_PageFrame, {
        modelValue: _ctx.state.step,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.step = $event)),
        class: ["form__content", _ctx.isPrivacyPolicy ? '-innerMaxWidth' : '-innerMaxWidthThin']
      }, _createSlots({
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.state.step === 0 ? "개인정보 제공 동의 " : "회원가입"), 1)
        ]),
        subtitle: _withCtx(() => [
          (_ctx.isPrivacyPolicy)
            ? (_openBlock(), _createBlock("span", _hoisted_2, [
                _hoisted_3,
                _hoisted_4,
                _hoisted_5
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_6
              ], 64))
        ]),
        content: _withCtx(() => [
          (_ctx.isPrivacyPolicy)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.privacyPolicyContent), {
                  onNextStep: _ctx.nextStep,
                  agreeAll: _ctx.agreeAll,
                  "onUpdate:agreeAll": _cache[1] || (_cache[1] = ($event: any) => (_ctx.agreeAll = $event))
                }, null, 8, ["onNextStep", "agreeAll"]))
              ]))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.signupForm), {
                key: 1,
                ref: "signupForm$"
              }, null, 512))
        ]),
        action: _withCtx(() => [
          _createVNode("div", _hoisted_10, [
            (_ctx.isPrivacyPolicy)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "-button -medium -royalBlue next-button",
                  onClick: _cache[3] || (_cache[3] = 
                () => {
                  _ctx.state.step += 1;
                }
              ),
                  disabled: !_ctx.agreeAll
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isPrivacyPolicy)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "-button -medium -royalBlue signup-button",
                  type: "button",
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, [
        (_ctx.isPrivacyPolicy)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_Checkbox, {
                    id: "agreeAll",
                    modelValue: _ctx.agreeAll,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreeAll = $event)),
                    binary: true,
                    class: "-royalBlue check-box"
                  }, null, 8, ["modelValue"]),
                  _hoisted_9
                ])
              ])
            }
          : undefined
      ]), 1032, ["modelValue", "class"])
    ])
  ], 512)), [
    [_directive_simpleHeader]
  ])
}